import { React,useState } from 'react';
import pokeLoading from '../images/pokeloading.gif';
import guessLoss from '../images/guessLoss.gif';
import hearLife from '../images/hearLife.png';
import { masterPokemonData } from "./Pokedata.js";
import introMusic from "../music/pokeStart.mp3";
import * as utils from "./common.js";


export default function GuessGame(props) {
    let masterPokeData = masterPokemonData;
    let pokemonNames = [];
    let ansName = "";
    let isOnline = true;
    let life = 3;
    let guessGameLevel = '';
    let minIndex = 0;
    let maxIndex = 354;
    let introVoice = new Audio(introMusic);
    


    const getGuessScore = (type) => {
        if (type === "HighScore") {
            if (guessGameLevel === 'EASY') {
                return localStorage.getItem("guessEasyHighScore");
            }
            else if (guessGameLevel === 'MEDIUM') {
                return localStorage.getItem("guessMediumHighScore");
            }
            else if (guessGameLevel === 'HARD') {
                return localStorage.getItem("guessHardHighScore");
            }
        } else if (type === "Score") {
            if (guessGameLevel === 'EASY') {
                return localStorage.getItem("guessEasyScore");
            }
            else if (guessGameLevel === 'MEDIUM') {
                return localStorage.getItem("guessMediumScore");
            }
            else if (guessGameLevel === 'HARD') {
                return localStorage.getItem("guessHardScore");
            }
        }
    }

    const setHidden = (elementId, flag) => {
        document.getElementById(elementId).hidden = flag;
    }

    const loadRandomName = (pokeIndex) => {
        ansName = "";
        ansName = masterPokeData.results[pokeIndex].name;
        let oneName = "";
        let twoName = "";
        pokemonNames = [];

        pokemonNames.push(ansName);
        // console.log(ansName, "ansName");
        if (pokeIndex >= 0 && pokeIndex < masterPokeData.results.length - 4) {
            oneName = masterPokeData.results[utils.getRandomNumber(0, pokeIndex + 2)].name;
        } else if (pokeIndex >= masterPokeData.length - 4) {
            oneName = masterPokeData.results[utils.getRandomNumber(0, (pokeIndex))].name;
        }
        if (pokeIndex >= 0 && pokeIndex < masterPokeData.results.length - 4) {
            twoName = masterPokeData.results[utils.getRandomNumber(0, (pokeIndex + 1))].name;
        } else if (pokeIndex >= masterPokeData.length - 4) {
            twoName = masterPokeData.results[utils.getRandomNumber(0, (pokeIndex - 5))].name;
        }

        pokemonNames.push(oneName);
        pokemonNames.push(twoName);

        pokemonNames = shuffleArray(pokemonNames);

        let divRef = document.getElementById("contentName");
        divRef.innerHTML = "";
        for (let i = 0; i < 3; i++) {
            let btn = document.createElement("button");
            btn.setAttribute("class", "col-md-3 m-2 btn btn-primary namebtn");
            btn.onclick = () => checkAns(pokemonNames[i]);
            btn.innerHTML = pokemonNames[i];
            divRef.appendChild(btn);
        }

        // console.log(ansName, oneName, twoName);
        return 1;
    }

    const loadRandomPokemonImage = (pokeIndex) => {
        // console.log(masterPokeData.results[pokeIndex].url)
        let url = masterPokeData.results[pokeIndex].url;
        let tempP = fetch(url)
        tempP.then((value1) => {
            return value1.json()
        }).then((value2) => {
            // console.log(value2, 'pokemondata');
            // console.log(value2.sprites.front_default, 'image url')
            // console.log(pokeIndex,"po")
            let pokeFrontImage = "";
            if ((value2.id < 755) || (value2.id >= 1000 && value2.id < 1011) || (value2.id >= 10000 && value2.id < 10264)) {
                // console.log("called")
                if (value2.id < 650) pokeFrontImage = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${value2.id}.svg`;
                else pokeFrontImage = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${value2.id}.png`;
            } else {
                pokeFrontImage = value2.sprites.front_default;
            }
            document.getElementById("randomPokemon").setAttribute("src", pokeFrontImage);
            if (loadRandomName(pokeIndex) === 1) {
                setHidden("contentName", false);
                setHidden("pokeMessage", true);
            }
        });


    }

    const shuffleArray = (array) => {
        for (var i = array.length - 1; i > 0; i--) {

            // Generate random number
            var j = Math.floor(Math.random() * (i + 1));

            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }
    const showScore = () => {
        let levelSelect = document.getElementById("gameLevel");
        if (localStorage.getItem("guessEasyHighScore") == null) localStorage.setItem("guessEasyHighScore", 0);
        if (localStorage.getItem("guessMediumHighScore") == null) localStorage.setItem("guessMediumHighScore", 0);
        if (localStorage.getItem("guessHardHighScore") == null) localStorage.setItem("guessHardHighScore", 0);

        guessGameLevel = "";
        guessGameLevel = levelSelect.value.trim().toUpperCase();
        if (guessGameLevel === '') {
            setHidden("levelMessage", false);
            utils.setBgRed("gameLevel", true);
            return;
        } else {
            setHidden("levelMessage", true);
            utils.setBgRed("gameLevel", false);
        }

        if (guessGameLevel === "EASY") {
            document.getElementById("levelHighScore").value = localStorage.getItem("guessEasyHighScore");
            minIndex = 0;
            maxIndex = parseInt(masterPokeData.results.length / 3);
        }
        else if (guessGameLevel === "MEDIUM") {
            document.getElementById("levelHighScore").value = localStorage.getItem("guessMediumHighScore");
            minIndex = parseInt(masterPokeData.results.length / 3);
            maxIndex = parseInt(masterPokeData.results.length / 3) * 2;
        }
        else if (guessGameLevel === "HARD") {
            document.getElementById("levelHighScore").value = localStorage.getItem("guessHardHighScore");
            minIndex = parseInt(masterPokeData.results.length / 3) * 2;
            maxIndex = parseInt(masterPokeData.results.length / 3) * 3;
        }
        // console.log(guessGameLevel, 'guessGameLevel', minIndex, 'minIndex', maxIndex, 'maxIndex');

    }


    const checkAns = (ans) => {
        if (ans === ansName) {
            if (guessGameLevel === 'EASY') {
                localStorage.setItem("guessEasyScore", parseInt(localStorage.getItem("guessEasyScore")) + 10);
            }
            else if (guessGameLevel === 'MEDIUM') {
                localStorage.setItem("guessMediumScore", parseInt(localStorage.getItem("guessMediumScore")) + 10);
            }
            else if (guessGameLevel === 'HARD') {
                localStorage.setItem("guessHardScore", parseInt(localStorage.getItem("guessHardScore")) + 10);
            }
            setHidden("tryMessage", true);
            setHidden("winMessage", false);
            disableAllName();
        } else {

            //Check user life
            life = life - 1;
            if (life < 1) {
                let currentScore = getGuessScore("Score");
                document.getElementsByClassName("heartIcon")[life].hidden = true;
                document.getElementById("randomPokemon").setAttribute("src", guessLoss);
                setHidden("tryMessage", true);
                setHidden("loseMessage", false);
                document.getElementById("guessScore").innerHTML = currentScore;
                disableAllName();
                return;
            } else {
                setHidden("tryMessage", false);
                document.getElementsByClassName("heartIcon")[life].hidden = true;
            }
        }
        let currentHighScore = getGuessScore("HighScore");
        let currentScore = getGuessScore("Score");
        document.getElementById("highScore").innerHTML = "High Score : " + currentHighScore;
        document.getElementById("yourScore").innerHTML = "Score :" + currentScore;

        if (parseInt(currentScore) > parseInt(currentHighScore)) {
            setGuessScore("HighScore", getGuessScore("Score"));
            document.getElementById("highScore").innerHTML = "High Score : " + currentHighScore;
        }
    }
    const disableAllName = () => {
        for (let i = 0; i < 3; i++) {
            document.getElementsByClassName("namebtn")[i].disabled = true;
        }
    }

    const setGuessScore = (type, scoreValue) => {
        if (type === "HighScore") {
            if (guessGameLevel === 'EASY') {
                localStorage.setItem("guessEasyHighScore", scoreValue);
            }
            else if (guessGameLevel === 'MEDIUM') {
                localStorage.setItem("guessMediumHighScore", scoreValue);
            }
            else if (guessGameLevel === 'HARD') {
                localStorage.setItem("guessHardHighScore", scoreValue);
            }
        } else if (type === "Score") {
            if (guessGameLevel === 'EASY') {
                localStorage.setItem("guessEasyScore", scoreValue);
            }
            else if (guessGameLevel === 'MEDIUM') {
                localStorage.setItem("guessMediumScore", scoreValue);
            }
            else if (guessGameLevel === 'HARD') {
                localStorage.setItem("guessHardScore", scoreValue);
            }
        }
    }

    const startGuessGame = () => {
        let levelSelect = document.getElementById("gameLevel");
        guessGameLevel = levelSelect.value.trim().toUpperCase();
        if (guessGameLevel === '') {
            setHidden("levelMessage", false);
            utils.setBgRed("gameLevel", true);
            return;
        } else {
            setHidden("levelMessage", true);
            utils.setBgRed("gameLevel", false);
        }
        setHidden("gussGame", false);
        setHidden("gameLevelDiv", true);
        playAgainGuess("Restart");
        introVoice.play();
    }
    const playAgainGuess = (event) => {
        if (event !== "Restart") {
            event = event.target.innerHTML.trim();
        }
        // return;
        let type = event;
        // console.log(type)
        if (type === 'Restart') {
            //reset Life
            for (let i = 0; i < 3; i++) {
                document.getElementsByClassName("heartIcon")[i].hidden = false;
            }
            life = 3;
            localStorage.setItem("guessEasyScore", 0);
            localStorage.setItem("guessMediumScore", 0);
            localStorage.setItem("guessHardScore", 0);
        }
        playGuessGame();
        introVoice.play();
    }

    const playGuessGame = () => {
        if (isOnline === false) return;
        //if highscore not set then 
        if (localStorage.getItem("guessHighSore") === null) localStorage.setItem("guessHighSore", 0);

        let guessHighScore = getGuessScore("HighScore");
        let currentScore = getGuessScore("Score");
        // console.log(guessHighScore, currentScore, localStorage.getItem("guessHighSore"));

        document.getElementById("randomPokemon").setAttribute("src", pokeLoading);
        document.getElementById("tryMessage").innerHTML = "Try Again";
        setHidden("pokeMessage", false);
        setHidden("tryMessage", true);
        setHidden("contentName", true);
        setHidden("winMessage", true);
        setHidden("loseMessage", true);
        document.getElementById("highScore").innerHTML = "High Score : " + guessHighScore;
        document.getElementById("yourScore").innerHTML = "Score :" + currentScore;

        loadRandomPokemonImage(utils.getRandomNumber(minIndex, maxIndex));
    }


    // useEffect(() => {
    //     console.log("Called");
    //     console.table(masterPokemonData);
    //     // playAgainGuess();
    // });
    return (
        <>
            <div className='container my-3'>
                <h1 className='text-center my-2'>GuessGame</h1>

                {/* <!-- guess level --> */}
                <div id="gameLevelDiv">
                    <div className="row g-2 mt-5">
                        <div className="col-md text-center">
                            <h5 htmlFor="levelHighScore" className="mb-1">High Score</h5>
                            <input type="text" className="form-control text-center" style={{ fontSize: "20px", fontFamily: "monospace" }} id="levelHighScore" placeholder="Level High Score" value="----" disabled />
                        </div>
                        <div className="col-md text-center">
                            <h5 htmlFor="gameLevel" className="mb-1">Game Level</h5>
                            <select className="form-select" id="gameLevel" style={{ fontSize: "20px", fontFamily: "monospace" }} onChange={showScore}>
                                <option value="">Select Level</option>
                                <option value="Easy">Easy</option>
                                <option value="Medium">Medium</option>
                                <option value="Hard">Hard</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-12 mt-2 text-center">
                        <h5 className="text-center text-danger" style={{ fontFamily: "monospace" }} id="levelMessage" hidden>Select Game Level</h5>
                    </div>
                    <div className="col-md-12 text-center mt-4">
                        <button className="startButton" onClick={startGuessGame}>Start </button>
                    </div>
                </div>

                {/* <!-- guess level end --> */}


                <div className="row mb-5 justify-content-center" id="gussGame" hidden>
                    <div className="row mb-2">
                        <h1 className="text-center mb-3 mt40 text-nowrap highScore" id="highScore">High Score</h1>
                        <div className="row">
                            <div className="col-5 text-center">
                                <h1 className="mb-3 text-nowrap" id="yourScore" style={{ fontFamily: "monospace !important", marginRight: "25px" }}>Score</h1>
                            </div>
                            <div className="col-1"></div>
                            <div className="col-1"></div>
                            <div className="col-1 mx-2">
                                <img src={hearLife} className="heartIcon" alt="" />
                            </div>
                            <div className="col-1 mx-2">
                                <img src={hearLife} className="heartIcon" alt="" />
                            </div>
                            <div className="col-1 mx-2">
                                <img src={hearLife} className="heartIcon" alt="" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-7">
                        <div className={`card height35vh bg-${props.mode === 'light' ? 'light cardShadowD' : 'black cardShadowW'}`} style={{ border: `2px solid ${props.mode === 'light' ? 'black' : 'white'}` }}>
                            <img src={pokeLoading} className={`card-img-top card-header border-${props.mode === 'light' ? 'light' : 'dark'}`} id="randomPokemon" alt="Unable to load..." />
                            <div className="card-body">
                                <div id="contentName" className="row justify-content-center" hidden></div>
                                <h2 className="text-success text-center mt-3 text-nowrap" id="winMessage" hidden>You Guessed It !!!<br /><span className="text-warning mx-4 next" td="continue" onClick={playAgainGuess}>Next &rarr;</span></h2>
                                <h2 className="text-danger text-center mt-3" id="tryMessage" hidden>Try again.</h2>
                                <h2 className="text-danger text-center mt-3" id="loseMessage" hidden>You Loss.Score <span id="guessScore"></span><span className="text-success mx-4 next" td="continue" onClick={playAgainGuess}> Restart </span></h2>
                                <h5 className="card-title" id="pokeMessage">Loading Please Wait...</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
